import { RootState } from '../types';

export const isLoading = (state: RootState) => state.email.isLoading;
export const error = (state: RootState) => state.email.error;
